import React, { useEffect, useState } from 'react';
import ButtonPrimary from '../button/primary';
import { FilterIcon } from 'lucide-react';
import { cn } from 'lib/utils';
import { useModal } from 'hooks/use-modal';

export const AdvancedFilterButton = () => {
    const [visible, setVisible] = useState(false);
    const { onOpen } = useModal();

    useEffect(() => {
        const handleScroll = () => {
            const scrollY = window.scrollY;

            if (scrollY > 200) {
                setVisible(true);
            } else {
                setVisible(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <ButtonPrimary
            type="button"
            icon={<FilterIcon />}
            onClick={() => onOpen('advanced-filter')}
            className={cn(
                'w-12 h-12 rounded-full fixed right-2 bottom-24 z-30 shadow-[rgba(0,0,0,0.24)_0px_3px_8px] md:hidden',
                'transition-all duration-300',
                visible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0',
            )}
        />
    );
};
